import { render } from "./AboutMission.vue?vue&type=template&id=0f4c04d4&scoped=true"
const script = {}

import "./AboutMission.vue?vue&type=style&index=0&id=0f4c04d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4c04d4"]])

export default __exports__